import React, { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { StatusToast, ToastContainer } from '@wix/design-system';
import s from './CopyNotification.module.scss';

type Props = {
  status: 'success' | 'error' | null;
  clearStatus: () => void;
  isMobileView: boolean;
};
const CopyNotification: FC<Props> = ({ status, clearStatus, isMobileView }) => {
  const { t } = useTranslation();

  if (!status) return null;

  const toastProps = {
    className: `${isMobileView ? s.mobileWidth : ''}`,
    duration: 8000,
    dismissible: true,
    onDismiss: () => clearStatus(),
  };

  const statusConfig = {
    success: {
      dataHook: 'profile-link-copy-notification-success',
      key: 'profile-page-share-link-copied',
      content: t('profile-page-nav-bar-link-copied'),
    },
    error: {
      dataHook: 'profile-link-copy-notification-failure',
      key: 'profile-page-share-link-copy-failure',
      content: t('profile-page-nav-bar-link-copy-failed'),
    },
  } as const;

  const config = statusConfig[status];

  const statusToast = (
    <StatusToast
      key={config.key}
      status={status}
      dataHook={config.dataHook}
      {...toastProps}
    >
      {config.content}
    </StatusToast>
  );

  return <ToastContainer>{statusToast}</ToastContainer>;
};

export default CopyNotification;
